import { render, staticRenderFns } from "./settinguser.vue?vue&type=template&id=ad12eefa"
import script from "./settinguser.vue?vue&type=script&lang=js"
export * from "./settinguser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports